<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/faq/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <data-list-item :faq="faq" @update="fetchFaq" />
      <b-row v-if="numberOfPages > 0">
        <b-colxx xxs="12">
          <b-pagination-nav
            size="sm"
            :number-of-pages="numberOfPages"
            :link-gen="linkGen"
            v-model="page"
            :per-page="perPage"
            align="center"
          >
            <template v-slot:next-text>
              <i class="simple-icon-arrow-right" />
            </template>
            <template v-slot:prev-text>
              <i class="simple-icon-arrow-left" />
            </template>
            <template v-slot:first-text>
              <i class="simple-icon-control-start" />
            </template>
            <template v-slot:last-text>
              <i class="simple-icon-control-end" />
            </template>
          </b-pagination-nav>
        </b-colxx>
      </b-row>
    </template>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/Faq/DataList.vue'
import { handleArrayDataInternalization } from '@/utils'

export default {
  components: { DataListItem },
  data() {
    return {
      page: this.$route.query.page || 1,
      perPage: 10,
      numberOfPages: 1,
      apiBase: '/api/dashboard/faq'
    }
  },
  computed: {
    apiUrl() {
      return `${this.apiBase}?page=${this.page}`
    },
    faq() {
      const faq = this.$store.getters['faq/faq']
      return handleArrayDataInternalization(faq, ['question', 'answer'], this.$i18n.locale)
    },
    isLoading() {
      return this.$store.getters['faq/isLoading']
    }
  },
  mounted() {
    this.fetchFaq()
  },
  methods: {
    linkGen(pageNum) {
      return { query: { page: pageNum } }
    },
    fetchFaq() {
      this.$store.dispatch('faq/fetchFaq', { vm: this })
    }
  },
  watch: {
    apiUrl() {
      this.fetchFaq()
    }
  }
}
</script>
